import * as React from "react";
import { Image, tokens, makeStyles, Subtitle2, Body1, Caption1, Menu, MenuTrigger, MenuList, MenuItem, MenuPopover, Link } from "@fluentui/react-components";

export interface HeaderProps {
  title: string;
  logo: string;
  message?: string;
  filterType?: 'workbook' | 'worksheet';
  onFilterChange?: (type: 'workbook' | 'worksheet') => void;
}

const useStyles = makeStyles({
  welcome__header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "6px",
    backgroundColor: tokens.colorNeutralBackground3,
  },
  leftContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  rightContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "center",
    marginRight: '12px'
  },
  logo: {
    margin: "4px",
    marginRight: "12px"
  },
  message: {
    textAlign: "right",
    color: tokens.colorNeutralForeground3,
  },
  filterContainer: {
    display: 'flex', 
    alignItems: 'baseline', 
    gap: '4px'
  },
  smallText: {
    fontSize: tokens.fontSizeBase200,
  }
});

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { title, logo, message, filterType, onFilterChange } = props;
  const styles = useStyles();

  return (
    <section className={styles.welcome__header}>
      <div className={styles.leftContainer}>
        <Image className={styles.logo} width="32" height="32" src={logo} alt={title} />
      </div>
      <div className={styles.rightContainer}>
        {filterType && onFilterChange && (
          <div className={styles.filterContainer}>
            <Caption1>Show items for:</Caption1>
            <Menu>
              <MenuTrigger disableButtonEnhancement>
                <Link as="button" className={styles.smallText}>{filterType === 'workbook' ? 'Whole workbook' : 'Current worksheet'}</Link>
              </MenuTrigger>
              <MenuPopover>
                <MenuList>
                  <MenuItem onClick={() => onFilterChange('workbook')}>Whole workbook</MenuItem>
                  <MenuItem onClick={() => onFilterChange('worksheet')}>Current worksheet</MenuItem>
                </MenuList>
              </MenuPopover>
            </Menu>
          </div>
        )}
        {message && <Caption1 className={styles.message}>{message}</Caption1>}
      </div>
    </section>
  );
};

export default Header;
